import styled from 'styled-components'
import {backgroundColor, darkGray, lightGray} from '@modifi/colors'
import {ButtonLink, media} from '@modifi/ui'

export const TableWrapper = styled.div`
  overflow-x: auto;
`

export const Table = styled.table`
  width: 500px;
  border-collapse: collapse;
  ${media.lg`
    width:  100%
  `}

  thead {
    background-color: ${backgroundColor};
    th {
      font-weight: 600;
      color: ${darkGray};
    }
  }
`

export const TableRow = styled.tr`
  text-align: left;
  border-collapse: collapse;
  height: 56px;
  :first-child {
    border-top: 1px solid ${lightGray};
  }
  border-bottom: 1px solid ${lightGray};
`

export const TableHead = styled.th`
  :first-child {
    padding-left: 8px;
  }
`

export const TableData = styled.td`
  padding: 0px 4px 0px 4px;
  :first-child {
    padding-left: 8px;
  }
`

export const StyledButtonLink = styled(ButtonLink)`
  text-align: left;
`
